import { render, staticRenderFns } from "./view-projects.vue?vue&type=template&id=1e7aebe1&scoped=true&"
import script from "./view-projects.vue?vue&type=script&lang=js&"
export * from "./view-projects.vue?vue&type=script&lang=js&"
import style0 from "./view-projects.vue?vue&type=style&index=0&id=1e7aebe1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7aebe1",
  null
  
)

export default component.exports